import React, {  useState } from 'react';
import {
  CardTitle,
  Card,
  CardContent,
  Option,
  Select,
  Button,
} from '../../../Components';
import { MonografiaModel, ProfessorModel } from '../../../Store';
import styled from 'styled-components';

interface IAlterarOrientadorModalProps {
  monografia: MonografiaModel,
  professores: ProfessorModel[]
  orientador: ProfessorModel,
  onSelectChange: (event: React.ChangeEvent<HTMLSelectElement>) => any,
  onAprovar: (monografiaId: number, professorId: number) => any
}

const StyledButton = styled(Button) <any>`
  margin-left: 16px
`;

const StyledSelect = styled(Select) <any>`
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 25px;
  grid-column: ${p => p.gridColumn};
`;

export default function AlterarOrientadorModal(props: IAlterarOrientadorModalProps) {
  const { monografia, professores, orientador, onSelectChange, onAprovar } = props;
  const [confirmar, setConfirmar] = useState(false)
  

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onSelectChange(event)
    setConfirmar(false)
  }

  const Options =
    <>
      <Option value={0}> Selecione um orientador... </Option>
      {professores.map(p => (
        <Option value={p.id} key={p.id}>
          {p.nome}
        </Option>
      ))}
    </>    

  return (
    <>
      {monografia && 
        <Card>         
          <CardTitle>Atribuir novo orientador para a monografia:</CardTitle>
          <CardContent>
            <StyledSelect
              name='orientador'
              value={orientador ? orientador.id : 0}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(e)}
              gridColumn='1/8'
            >
              {Options}
            </StyledSelect>
            {!confirmar &&
              <StyledButton
                onClick={() => setConfirmar(true)}>
                Atribuir
              </StyledButton>
            }
            {confirmar &&
              <StyledButton
                onClick={() => onAprovar(monografia.id, orientador && orientador.id)}>
                Confirmar
            </StyledButton>
            }
          </CardContent>
        </Card>
      }
    </>
  );
}
